import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import CampaignRaffleForm from '@/components/v2/survey/CampaignRaffleForm.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import RaffleDrawCreate from '@/plugins/graphql/mutations/v2/survey/raffle-campaign-draw-create.gql';
import { successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import RaffleDraws from '@/plugins/graphql/queries/v2/survey/raffle-draws.gql';
import PromoCodeMixin from '@/helpers/vue_mixins/v2/ecommerce/PromoCodeMixin';
let CampaignRaffleCreate = class CampaignRaffleCreate extends mixins(AlertMixin, RouterParamsAppMixin, PromoCodeMixin) {
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.create(form)
            .then(() => {
            const msg = successfulCreate('Raffle Draw');
            this.successNotification(msg);
            this.goToRaffleDrawDetailsPage(this.createdDrawUuid);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    goToRaffleDrawDetailsPage(uuid) {
        this.$router.push({
            name: 'raffle-draw-details',
            params: {
                uuid,
            },
        });
    }
    async create(form) {
        const appUuid = this.appUUID;
        const vm = this;
        const { name, description, prize, campaignUuid, taskUuid, repeatWinner } = form;
        await this.$apollo.mutate({
            mutation: RaffleDrawCreate,
            variables: {
                input: {
                    name,
                    description,
                    prize,
                    campaignUuid,
                    taskUuid,
                    repeatWinner,
                    winnerCount: Number(form.winnerCount),
                    appUuid,
                },
            },
            update(cache, { data }) {
                const queryOptions = {
                    query: RaffleDraws,
                    variables: {
                        appUuid,
                    },
                };
                const createdDraw = data.raffleCampaignDraw.raffleDraw;
                vm.createdDrawUuid = createdDraw.uuid;
                const { raffleDraws } = cache.readQuery({
                    ...queryOptions,
                });
                if (!raffleDraws) {
                    return;
                }
                const cachedRaffleDraws = {
                    ...raffleDraws,
                };
                cachedRaffleDraws.edges.unshift({
                    node: createdDraw,
                    __typename: 'RaffleDrawEdges',
                });
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        raffleDraws: cachedRaffleDraws,
                    },
                });
            },
        });
    }
};
CampaignRaffleCreate = __decorate([
    Component({
        components: {
            PageTitle,
            CampaignRaffleForm,
        },
    })
], CampaignRaffleCreate);
export default CampaignRaffleCreate;
